// extracted by mini-css-extract-plugin
export default {"c-page":"Page_c-page__syyTl","c-page__main":"Page_c-page__main__YhdDG"};